import { useGetOnMount } from 'hooks/useGetOnMount';
import { ACCOUNT_API_EVENT_LOG } from 'apiRoutes';
import { AuditLogTable } from 'components/common/AuditLogTable/AuditLogTable';
import { auditLogTableColumns } from 'components/common/AuditLogTable/auditLogTableColumns';
import { FunctionComponent, useMemo, useState } from 'react';
import { AuditLogEvent } from 'components/common/AuditLogTable/AuditLogEvent';
import { SubscriptionUpdatedDetailsModal } from 'pages/Subscription/SubscriptionUpdatedDetailsModal/SubscriptionUpdatedDetailsModal';

export const AdminAuditLog: FunctionComponent<{ adminId: string }> = ({
	adminId,
}) => {
	const { data, status } = useGetOnMount<AuditLogEvent[]>(
		`${ACCOUNT_API_EVENT_LOG}/GetEvents?adminId=${adminId}`,
	);

	const [showModal, setShowModal] = useState(false);
	const [selectedEventData, setSelectedEventData] = useState<any>(null);

	const columns = useMemo(
		() => [
			auditLogTableColumns.time(),
			auditLogTableColumns.message(),
			auditLogTableColumns.account(),
			auditLogTableColumns.application(),
			auditLogTableColumns.company(),
			auditLogTableColumns.subscription(),
			auditLogTableColumns.comment(),
			auditLogTableColumns.details(undefined, (data: any) => {
				setSelectedEventData(data);
				setShowModal(true);
			}),
		],
		[data],
	);

	return (
		<>
			<AuditLogTable
				requestStatus={status}
				data={data}
				columns={columns}
			/>
			<SubscriptionUpdatedDetailsModal
				isOpen={showModal}
				onClose={() => setShowModal(false)}
				eventData={selectedEventData}
			/>
		</>
	);
};
